export const FETCH_MUSIC_LINKS_LIST = 'MUSIC-LINKS/FETCH_MUSIC_LINKS_LIST';
export const FETCH_MUSIC_LINKS_LIST_ERROR = 'MUSIC-LINKS/FETCH_MUSIC_LINKS_LIST_ERROR';
export const CLEAR_MUSIC_LINKS_LIST = 'MUSIC-LINKS/CLEAR_MUSIC_LINKS_LIST';

export const FETCH_MUSIC_LINK_DETAILS = 'MUSIC-LINKS/FETCH_MUSIC_LINK_DETAILS';
export const FETCH_MUSIC_LINK_DETAILS_ERROR = 'MUSIC-LINKS/FETCH_MUSIC_LINK_DETAILS_ERROR';
export const CLEAR_MUSIC_LINK_DETAILS = 'MUSIC-LINKS/CLEAR_MUSIC_LINK_DETAILS';

export const ADD_MUSIC_LINK_SUCCESS = 'MUSIC-LINKS/ADD_MUSIC_LINK_SUCCESS';
export const ADD_MUSIC_LINK_ERROR = 'MUSIC-LINKS/ADD_MUSIC_LINK_ERROR';
export const CLEAR_MUSIC_LINK_STATUS = 'MUSIC-LINKS/CLEAR_MUSIC_LINK_STATUS';

export const PATCH_MUSIC_LINK_SUCCESS = 'MUSIC-LINKS/PATCH_MUSIC_LINK_SUCCESS';
export const PATCH_MUSIC_LINK_ERROR = 'MUSIC-LINKS/PATCH_MUSIC_LINK_ERROR';
export const CLEAR_MUSIC_LINK_PATCH_STATUS = 'MUSIC-LINKS/CLEAR_MUSIC_LINK_PATCH_STATUS';

export const PATCH_MUSIC_MEDIA_SAMPLE_SUCCESS = 'MUSIC-LINKS/PATCH_MUSIC_MEDIA_SAMPLE_SUCCESS';
export const PATCH_MUSIC_MEDIA_SAMPLE_ERROR = 'MUSIC-LINKS/PATCH_MUSIC_MEDIA_SAMPLE_ERROR';
export const CLEAR_MUSIC_MEDIA_SAMPLE_PATCH_STATUS = 'MUSIC-LINKS/CLEAR_MUSIC_MEDIA_SAMPLE_PATCH_STATUS';

export const UPDATE_MUSIC_LINK_SOURCE_SUCCESS = 'MUSIC-LINKS/UPDATE_MUSIC_LINK_SOURCE_SUCCESS';
export const UPDATE_MUSIC_LINK_SOURCE_ERROR = 'MUSIC-LINKS/UPDATE_MUSIC_LINK_SOURCE_ERROR';
export const CLEAR_MUSIC_LINK_UPDATE_SOURCE_STATUS = 'MUSIC-LINKS/CLEAR_MUSIC_LINK_UPDATE_SOURCE_STATUS';

export const DELETE_MUSIC_LINK_SUCCESS = 'MUSIC-LINKS/DELETE_MUSIC_LINK_SUCCESS';
export const DELETE_MUSIC_LINK_ERROR = 'MUSIC-LINKS/DELETE_MUSIC_LINK_ERROR';
export const CLEAR_MUSIC_LINK_DELETE_STATUS = 'MUSIC-LINKS/CLEAR_MUSIC_LINK_DELETE_STATUS';

export const APPLY_MUSIC_LINK_DRAG = 'MUSIC-LINKS/APPLY_MUSIC_LINK_DRAG';
export const APPLY_MUSIC_LINK_DRAG_ERROR = 'MUSIC-LINKS/APPLY_MUSIC_LINK_DRAG_ERROR';
export const CLEAR_MUSIC_LINK_DRAG = 'MUSIC-LINKS/CLEAR_MUSIC_LINK_DRAG';

export const ADD_MUSIC_SERVICE_LINK_SUCCESS = 'MUSIC-LINKS/ADD_MUSIC_SERVICE_LINK_SUCCESS';
export const ADD_MUSIC_SERVICE_LINK_ERROR = 'MUSIC-LINKS/ADD_MUSIC_SERVICE_LINK_ERROR';
export const CLEAR_ADD_MUSIC_SERVICE_LINK = 'MUSIC-LINKS/CLEAR_ADD_MUSIC_SERVICE_LINK';

export const PATCH_MUSIC_SERVICE_LINK_SUCCESS = 'MUSIC-LINKS/PATCH_MUSIC_SERVICE_LINK_SUCCESS';
export const PATCH_MUSIC_SERVICE_LINK_ERROR = 'MUSIC-LINKS/PATCH_MUSIC_SERVICE_LINK_ERROR';
export const CLEAR_PATCH_MUSIC_SERVICE_LINK = 'MUSIC-LINKS/CLEAR_PATCH_MUSIC_SERVICE_LINK';

export const DELETE_MUSIC_SERVICE_LINK_SUCCESS = 'MUSIC-LINKS/DELETE_MUSIC_SERVICE_LINK_SUCCESS';
export const DELETE_MUSIC_SERVICE_LINK_ERROR = 'MUSIC-LINKS/DELETE_MUSIC_SERVICE_LINK_ERROR';
export const CLEAR_DELETE_MUSIC_SERVICE_LINK = 'MUSIC-LINKS/CLEAR_DELETE_MUSIC_SERVICE_LINK';
